import { Plan } from "./plan.interface";

export class CreatePlanDto {
  title: string;
  description: string;

  constructor(plan: Plan) {
    this.title = plan.title;
    this.description = plan.description;
  }
}

export class UpdatePlanDto {
  title: string;
  description: string;

  constructor(plan: Plan) {
    this.title = plan.title;
    this.description = plan.description;
  }
}